import numberOnly from './number-only';
import removeAriaHidden from './remove-aria-hidden';
import permissionDirective from './permission-directive';
// 指令集
const directives = {
    numberOnly,
    removeAriaHidden,
    permission: permissionDirective,
    // 添加更多指令...
};

/**
 * 批量注册指令
 * @param {Vue} Vue Vue实例
 */
export default {
    install(Vue) {
        Object.keys(directives).forEach(key => {
            Vue.directive(key, directives[key]);
        });
    }
};

// 单独导出每个指令，便于按需导入
export { numberOnly, removeAriaHidden, permissionDirective as permission, };

// 获取指令配置
export const getDirectives = () => {
    return Object.keys(directives).map(key => ({
        name: key,
        description: directives[key].__description || '暂无描述',
        usage: directives[key].__usage || '暂无使用说明'
    }));
};